class AboutUsNav extends HTMLElement {
  constructor() {
    super();
    this.links = this.querySelectorAll('.about-us-nav__link');
    this.linkBackground = this.querySelector('.about-us-nav__link-background');

    this.links.forEach(link => {
      link.addEventListener('click', this.onLinkClick.bind(this));
    })

    document.addEventListener('DOMContentLoaded', this.updateLinkBackground.bind(this));
    window.addEventListener('resize', this.updateLinkBackground.bind(this));
  }

  onLinkClick(e) {
    const link = e.target;

    e.preventDefault();
    const headerHeight = parseInt(getComputedStyle(document.querySelector('.sticky-header')).height);
    const relatedSection = document.getElementById(link.getAttribute('data-section'));

    // 1. 'active' class
    this.links.forEach(el => el.classList.remove('active'));
    link.classList.add('active');

    // 2. Link Background
    this.linkBackground.classList.add('animate');
    this.updateLinkBackground();

    // 3. scroll
    document.body.scrollTop = relatedSection.offsetTop - headerHeight;
    document.documentElement.scrollTop = relatedSection.offsetTop - headerHeight;
  }

  updateLinkBackground() {
    this.links.forEach(link => {
      if (link.classList.contains('active')) {
        this.linkBackground.style.width = getComputedStyle(link).width;
        this.linkBackground.style.left = `${link.offsetLeft}px`;
      }
    })
  }
}

customElements.define('about-us-nav', AboutUsNav);



